import React, { useState, useRef, useEffect } from "react";

const SaveViewModal = ({ onClose, onConfirm }) => {
  const [name, setName] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
  };

  return (
    <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black/20" onMouseDown={onClose}>
      <div className="w-full max-w-sm rounded-lg bg-white p-6" onMouseDown={(e) => e.stopPropagation()}>
        <h2 className="mb-4 text-lg font-medium text-gray-900">Enregistrer la vue</h2>
        <form onSubmit={handleSubmit}>
          <input
            ref={inputRef}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Nom de la vue"
            className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none transition-colors focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
          />
          <div className="mt-4 flex justify-end gap-2">
            <button type="button" className="rounded-lg px-4 py-2 text-sm text-gray-600 transition-colors hover:bg-gray-100" onClick={onClose}>
              Annuler
            </button>
            <button
              type="submit"
              disabled={!name.trim()}
              className="rounded-lg bg-primary-500 px-4 py-2 text-sm text-white transition-colors hover:bg-primary-600 disabled:opacity-50"
            >
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SaveViewModal;
